import AiWorkbench from './AiWorkbench';

export default AiWorkbench;